var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 25") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(100, 100, 100)"
    },
    d: "M23,6a.8.8,0,0,0-.06-.3.64.64,0,0,0,0-.07s0,0,0,0l-2-4A1,1,0,0,0,20,1H3a1,1,0,0,0-1,.76l-1,4a.34.34,0,0,0,0,.1A.7.7,0,0,0,1,6V22a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V6S23,6,23,6ZM3.78,3h15.6l1,2H3.28ZM21,21H3V7H21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c8542"
    },
    d: "M11.45,18.83a1,1,0,0,0,1.1,0l3-2a1,1,0,1,0-1.1-1.66l-1.45,1V10a1,1,0,0,0-2,0v6.13l-1.45-1a1,1,0,0,0-1.1,1.66Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.7ec98b8022e385a1508bc0a18b438e0a.svg";
export { ForwardRef as ReactComponent };